import { MantineReactTable, type MRT_ColumnDef } from 'mantine-react-table'
import { useMemo } from 'react'
import { PillowType, PillowVariant, Place } from 'types/products'
import { placeFilterFn } from 'utils'
import { sizeSortingFn, useProductTable } from './ProductTable'

type Props = {
  variants: Array<PillowVariant>
  highlightItemId?: string
}

export default function PillowTable({ variants, highlightItemId }: Props) {
  const columns = useMemo<Array<MRT_ColumnDef<PillowVariant>>>(
    () => [
      {
        accessorKey: 'pillowType',
        header: 'Rodzaj',
        size: 100,
        Cell: ({ cell }) => (cell.getValue<PillowType>() === PillowType.FABRIC ? 'Materiał' : 'Gotowa'),
        filterVariant: 'select',
        mantineFilterSelectProps: {
          data: Object.values(PillowType).map((place) => ({
            value: place,
            label: place === PillowType.FABRIC ? 'Materiał' : 'Gotowa',
          })),
        },
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po rodzaju',
        },
      },
      {
        accessorKey: 'size',
        header: 'Rozmiar (cm)',
        size: 100,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po rozmiarze',
        },
        sortingFn: sizeSortingFn,
      },
      {
        accessorKey: 'stock',
        header: 'Ilość sztuk',
        size: 100,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po ilości',
        },
      },
      {
        accessorKey: 'place',
        header: 'Półka',
        enableSorting: false,
        size: 100,
        Cell: ({ cell }) => {
          const place = cell.getValue<Place>()
          return `${place.rack}-${place.column}-${place.shelf}`
        },
        filterFn: placeFilterFn,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po półce',
        },
      },
      {
        accessorKey: 'feature',
        header: 'Cecha',
        enableSorting: false,
        size: 120,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po cesze',
        },
      },
      {
        accessorKey: 'comments',
        header: 'Uwagi',
        enableSorting: false,
        size: 120,
        mantineFilterTextInputProps: {
          placeholder: 'Filtruj po uwagach',
        },
      },
    ],
    []
  )
  const table = useProductTable({
    columns,
    data: variants,
    highlightItemId,
  })
  return <MantineReactTable table={table} />
}
